import React from "react";
//#region types
import { MoreActionButtonProps } from "models/propTypes/commonPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid, ButtonGroup } from "@mui/material";
import StyledButton from "./styledButton";
import MenuButton from "./menuButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const MoreActionsButton: React.FC<MoreActionButtonProps> = (props) => {
  return (
    <Grid container direction="column" alignItems={props.alignItems ?? "center"} className={props.className}>
      <ButtonGroup disabled={props.disabled}>
        <StyledButton {...props} className={cssExports.btnSplitLeft}>
          {props.children}
        </StyledButton>
        <MenuButton
          menuPlacement={props.menuPlacement ?? "top"}
          menuItems={props.menuItems}
          onActionSuccess={props.onActionSuccess}
          button={
            <StyledButton
              displayType={props.displayType}
              disabled={props.disabled}
              size={props.size}
              className={cssExports.btnSplitRight}
            >
              <Icon icon={IconDefinitionConstants.WDropArrowSmall} />
            </StyledButton>
          }
        />
      </ButtonGroup>
    </Grid>
  );
};

export default MoreActionsButton;
